import _Message from "@arco-design/web-react/es/Message";
import axios from 'axios';
var isOtherService = function isOtherService(url) {
  if (url.indexOf(location.origin + '/themes') !== 0) {
    return true;
  }
  return false;
};
export function formatError(error) {
  var response = error.response;
  var data = response && response.data;
  if (response && (response.status === 401 || response.status === 302)) {
    window.location.href = data && data.url + '?redirectUrl=' + location.href;
    return;
  }
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (err) {
      console.error(err, 'parse');
    }
  }
  return data;
}
axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (res) {
  return res;
}, function (err) {
  var data = formatError(err);
  var messageError = err.config.messageError;
  if (messageError !== false) _Message.error(data.msg || 'Request Error');
  return Promise.reject(err);
});
axios.interceptors.response.use(function (response) {
  var res = response.data;
  var messageError = Reflect.get(response.config, 'messageError');
  if (isOtherService(response.request.responseURL)) {
    return response;
  }
  if (!res.status) {
    if (messageError !== false) {
      _Message.error({
        content: res.msg || 'Request Error',
        duration: 5 * 1000
      });
    }
    return Promise.reject(new Error(res.msg || 'Request Error'));
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});